/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-08-02 11:48:30
 * @LastEditors: K
 * @LastEditTime: 2022-08-02 13:52:58
 */
import { ADMIN_API_PREFIX } from './constant'
import { Request } from './request'

export interface getPriceSetFnParams {
  id?: string[]
  price?: string
}
//  修改新增代煎供应商
export const getPriceSetFn = (body: getPriceSetFnParams): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/order/tenantProductPriceUpdate`,
    method: 'POST',
    body,
  }
}
